import { createContext, useContext } from 'react'

export type EvervaultLoadStatus = 'loading' | 'ready' | 'error'

export interface EvervaultLoadState {
  status: EvervaultLoadStatus
  /** Set when `status` is `error`: the SDK script failed to load. */
  error: Error | null
  /** Number of `reload()` calls so far; 0 for the initial load. */
  attempt: number
  /** Re-injects the Evervault script and re-runs card iframe mounts. */
  reload: () => void
}

const noop = () => {
  /* no provider mounted (SSR, tests) */
}

export const EvervaultLoadStateContext = createContext<EvervaultLoadState>({
  status: 'loading',
  error: null,
  attempt: 0,
  reload: noop
})

export const useEvervaultLoadState = (): EvervaultLoadState =>
  useContext(EvervaultLoadStateContext)
